import { BHTag } from '@bh/components'
import { TypeOptions } from 'react-toastify'

interface QuoteStatusRendererProps {
  displayText: string
}

export default function QuoteStatusRenderer({
  displayText,
}: QuoteStatusRendererProps) {
  function getTagType(text: string): TypeOptions {
    switch (text) {
      case 'Saved':
        return 'info'
      case 'Pending':
        return 'warning'
      case 'Available':
        return 'default'
      case 'Ordered':
        return 'success'
      case 'Expired':
        return 'error'
      default:
        return 'default'
    }
  }

  const tagType: TypeOptions = getTagType(displayText)

  return <BHTag status={tagType} text={displayText} />
}
